import axios from "axios";
import {
  api_url,
  aqua_base_url,
  SHARE_MARKET_BASE_URL,
  SHARE_PROFILE_BASE_URL
} from "./Enviroment";
import { FEATURE_BLOG_CATEGORY_ID } from "./constants";
import { convertFromWeiEthers } from "./helpers";

const ORDER_BOOk_URL = `${api_url}/orders/order-book`;
const ethPrice = "https://pro-api.coingecko.com/api/v3/simple/price";
const LIVE_STREAMING = `${api_url}/pools/update-streaming`;
const SANTA_REWARD = `${api_url}/users/santa-reward`;
const POST_REFERRAL_POINTS = `${api_url}/points/user-succesfull-onboarding`;
const POST_USER_REWARD_POINTS = `${api_url}/points/add-user-points`;
const GET_USER_POINTS_HISTORY = `${api_url}/points/get-user-points`;
const GET_USER_PROFILE_HISTORY = `${api_url}/users/get-user-history`;
const GET_USER_PROFILE = `${api_url}/users/user-profile`;
const GET_USER_INVESTMENT = `${api_url}/investments/user-over-all-investment`;
const GET_USER_NOTIFICATION = `${api_url}/notifications/get-notifications`;
const GET_CREATED_POOL = `${api_url}/pools/poolByContractAddress`;
const GET_EXTEND_SIGNATURE = `${api_url}/pools/sign-oracles-extend-time`;
const POST_CLOSE_POOL = `${api_url}/pools/update-pool-resolution-time`;
const TOTAL_PARTICIPANTS_COUNT = `${api_url}/users/users-total-count`;
const TOTAL_RAIN_TOKEN_BURNED = `${api_url}/rain-token/total-burned`;
const TOTAL_MARKETS = `${api_url}/pools/get-all-pools-count`;
const SEARCH_MARKETS = `${api_url}/pools/search-pool`;
const RELATED_MARKETS = `${api_url}/pools/get-related-pools`;
const AQUA_SWAP_URL = `${aqua_base_url}/api/swap/swap-asset`;
const POST_CREATE_POOL_FALLBACK = `${api_url}/pools/find-pool-fallback`;
const MARK_AS_READ = `${api_url}/notifications/mark-notification-as-read`;
const MARK_ALL_AS_READ = `${api_url}/notifications/mark-all-as-read`;
const GENERATE_PREVIEW = `${SHARE_MARKET_BASE_URL}preview/generate-preview`;
const GENERATE_PROFILE_PREVIEW = `${SHARE_PROFILE_BASE_URL}profile/generate-profile-preview`;
const GET_FEATURED_MARKETS = `${api_url}/pools/get-featured-pools`;
const POST_DISPUTE_MESSAGE = `${api_url}/dispute/create-dispute-message`;
const GET_DISPUTE_MESSAGE = `${api_url}/dispute/get-pool-dispute-convo`;
const GET_DISPUTE_HISTORY = `${api_url}/pools/get-pool-resolution-history`;
const API_URL_BLOGS = 'https://blogs.rain.one/wp-json/wp/v2/';
const FETCH_USER_PROFILE_POOLS = `${api_url}/users/view-user-profile/`
const FOLLOW_TOGGLE = `${api_url}/follow/toggle`;
const RISK_MARKET_DISCLAIMER = `${api_url}/crash-game/update-disclaimer-status`;
const FOLLOW_CHECK = `${api_url}/follow/check`;
const FOLLOW_FOLLOWERS = `${api_url}/follow/followers`;
const FOLLOW_FOLLOWING = `${api_url}/follow/following`;
const PROFILE_TOTAL_VOLUME = `${api_url}/investments/calculate-user-total-volume`;
const USER_PNL_GRAPH = `${api_url}/investments/get-user-pnl-graph`;
const FOLLOW_STATS = `${api_url}/follow/stats`;
const GET_USER_LIVE_POOLS_COUNT = `${api_url}/investments/user-invested-live-pools-count`
const GET_PREDICTED_MARKET = `${api_url}/investments/user-invested-pools`
const GET_PROFILE_PNL = `${api_url}/investments/calculate-user-PNL-per-pool`
const GET_ONGOING_BETS = `${api_url}/crash-game/reveal`
const GET_GAME_PROGRESS = `${api_url}/crash-game/isCrashed`
const GET_GAME_ACTIVE_PLAYERS = `${api_url}/crash-game/crash-round-players`
const GET_CASHOUT_SIGNATURE = `${api_url}/crash-game/cashout`
const GET_GRAPH_PRICES = `${api_url}/price-data/get-price-data`
const GET_OPEN_INTEREST = `${api_url}/investments/calculate-user-open-interest`
const GENERATE_RISK_MARKET_PNL_PREVIEW = `${SHARE_MARKET_BASE_URL}riskMarket/generate-risk-preview`;


export const getOrdersListing = async (poolId, accessToken, key, tokenDecimals) => {
  try {
    const url = `${api_url}/orders/get-user-order-by-poolId/${poolId}?filter=${key}`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    const ordersResData = response.data.data;
    const ordersWithConvertedValues = ordersResData?.map((order) => ({
      ...order,
      quantity: convertFromWeiEthers(order.quantity, tokenDecimals),
    }));

    return ordersWithConvertedValues;
  } catch (error) {
    console.error("An error occurred while fetching the orders.", error);
  }
};

export const getOrderBookData = async (poolId, limit) => {
  try {
    const orderBookResponse = await axios.get(
      `${ORDER_BOOk_URL}?pool=${poolId}&limit=${limit}`
    );
    return orderBookResponse?.data?.data;
  } catch (error) {
    console.error(
      "An error occurred while fetching the order book data.",
      error
    );
  }
};

export const postLiveStreaming = async (payload) => {
  const token = localStorage.getItem("accessToken");
  try {
    const livestreamingResponse = await axios.post(LIVE_STREAMING, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error(error);
  }
};


export const postSantaRewardRecieved = async () => {
  const token = localStorage.getItem("accessToken");
  try {
    const santaRewardRecievedResponse = await axios.post(SANTA_REWARD, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return santaRewardRecievedResponse;
  } catch (error) {
    console.error(error);
  }
};

export const postDisputeMessage = async (payload) => {
  const token = localStorage.getItem("accessToken");
  try {
    const disputeMessageResponse = await axios.post(POST_DISPUTE_MESSAGE, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return disputeMessageResponse;
  } catch (error) {
    console.error(error);
  }
};

export const getUsersPnlGraph = async (duration) => {
  const token = localStorage.getItem("accessToken");
  try {
    const userPnlGraph = await axios.get(`${USER_PNL_GRAPH}?timeframe=${duration}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return userPnlGraph?.data?.data;
  } catch (error) {
    console.error("error: ", error);
  }
};

export const getDisputeMessage = async (poolId) => {
  try {
    const disputeMessageResponse = await axios.get(`${GET_DISPUTE_MESSAGE}/${poolId}`)
    return disputeMessageResponse?.data?.data;
  } catch (error) {
    console.error(error);
  }
};

export const getDisputeHistory = async (poolId) => {
  try {
    const disputeHistoryResponse = await axios.get(`${GET_DISPUTE_HISTORY}/${poolId}`)
    return disputeHistoryResponse?.data?.data;
  } catch (error) {
    console.error(error);
  }
};

export const ethToDollarConverter = async () => {
  try {
    const response = await axios.get(ethPrice, {
      params: {
        ids: "ethereum",
        vs_currencies: "usd",
      },
      headers: {
        "x-cg-pro-api-key": "CG-Qa4xRCrDuHn2232ArjgSwA8g",
      },
    });
    return response?.data?.ethereum?.usd;
  } catch (error) {
    console.error("Error fetching ETH price:", error);
  }
};

export const tokenToDollarConvertion = async (token) => {
  try {
    const tokenToLowerCase = token?.toLowerCase()
    const response = await axios.get(ethPrice, {
      params: {
        ids: tokenToLowerCase,
        vs_currencies: "usd",
      },
      headers: {
        "x-cg-pro-api-key": "CG-Qa4xRCrDuHn2232ArjgSwA8g",
      },
    });
    return response?.data?.rain?.usd;
  } catch (error) {
    console.error("Error fetching Rain price:", error);
  }
};

export const postUserReferralPoints = async (payload) => {
  const token = localStorage.getItem("accessToken");
  try {
    const userRewardPoints = await axios.post(POST_REFERRAL_POINTS, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const postUserRewardPoints = async (payload) => {
  const token = localStorage.getItem("accessToken");
  try {
    const userRefrealPoints = await axios.post(
      POST_USER_REWARD_POINTS,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    console.error(error);
  }
};

export const getUserPoints = async () => {
  const token = localStorage.getItem("accessToken");
  try {
    const getUserPointHistory = await axios.get(GET_USER_POINTS_HISTORY, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return getUserPointHistory?.data;
  } catch (error) {
    console.error(error);
  }
};
export const getFeaturedMarekets = async () => {
  try {
    const getFeaturedMareketsResponse = await axios.get(GET_FEATURED_MARKETS);
    return getFeaturedMareketsResponse?.data?.data?.pools;
  } catch (error) {
    console.error(error);
  }
};

export const getUsersProfile = async () => {
  const token = localStorage.getItem("accessToken");
  try {
    const userProfile = await axios.get(GET_USER_PROFILE, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return userProfile;
  } catch (error) {
    console.error("error: ", error);
  }
};

export const getUsersInvestment = async () => {
  const token = localStorage.getItem("accessToken");
  try {
    const userInvesment = await axios.get(GET_USER_INVESTMENT, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return userInvesment;
  } catch (error) {
    console.error("error: ", error);
  }
};

export const getUsersNotification = async (status) => {
  const token = localStorage.getItem("accessToken");
  try {
    const userNotification = await axios.get(
      `${GET_USER_NOTIFICATION}?status=${status}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return userNotification?.data?.data;
  } catch (error) {
    console.error("error: ", error);
  }
};

export const getCreatedPool = async (poolAddress) => {
  const token = localStorage.getItem("accessToken");
  try {
    const createdPoolData = await axios.get(
      `${GET_CREATED_POOL}/${poolAddress}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return createdPoolData?.data?.data;
  } catch (error) {
    console.error("An error occurred while fetching created pool data.", error);
  }
};

export const getExtendTimeAndSignature = async (poolAddress, smartAccount) => {
  const token = localStorage.getItem("accessToken");
  try {
    const extendTimeSign = await axios.get(
      `${GET_EXTEND_SIGNATURE}?contractAddress=${poolAddress}&walletAddress=${smartAccount}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return extendTimeSign?.data?.data;
  } catch (error) {
    console.log("error: ", error);
  }
};

export const postClosePool = async (poolID, resolutionTime = null) => {
  const token = localStorage.getItem("accessToken");
  try {
    const payload = { poolId: poolID };
    if (resolutionTime !== null) {
      payload.resolutionTime = resolutionTime;
    }
    const poolclosed = await axios.post(`${POST_CLOSE_POOL}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return poolclosed;
  } catch (error) {
    console.log("error: ", error);
  }
};

export const getTotalPoolsParticipants = async () => {
  try {
    const participants = await axios.get(`${TOTAL_PARTICIPANTS_COUNT}`);
    return participants?.data?.data?.totalUsers;
  } catch (error) {
    console.log("error: ", error);
  }
};

export const getTotalRainTokenBurned = async () => {
  try {
    const tokens = await axios.get(`${TOTAL_RAIN_TOKEN_BURNED}`);
    return tokens?.data?.details?.totalBurned;
  } catch (error) {
    console.log("error: ", error);
  }
};

export const getMarkets = async () => {
  try {
    const marketsRes = await axios.get(`${TOTAL_MARKETS}`);
    return marketsRes?.data?.data?.poolsCount;
  } catch (error) {
    console.log("error: ", error);
  }
};

export const getSearchedMarkets = async (query) => {
  try {
    const searchedRes = await axios.get(`${SEARCH_MARKETS}`, {
      params: { question: query },
    });
    return searchedRes.data?.data;
  } catch (error) {
    console.error("error:", error);
    return [];
  }
};

export const getRelatedMarkets = async (id) => {
  try {
    const relatedRes = await axios.get(
      `${RELATED_MARKETS}/${id}?limit=3&offset=1`
    );
    return relatedRes.data?.data;
  } catch (error) {
    console.error("error:", error);
  }
};

export const postCreatePoolFallBack = async (payload) => {
  const token = localStorage.getItem("accessToken");
  try {
    const poolclosed = await axios.post(
      `${POST_CREATE_POOL_FALLBACK}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return poolclosed;
  } catch (error) {
    console.log("error: ", error);
  }
};

export const postAllNotificationAsRead = async () => {
  const token = localStorage.getItem("accessToken");
  try {
    const markAllAsRead = await axios.post(
      `${MARK_ALL_AS_READ}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return markAllAsRead;
  } catch (error) {
    console.log("error: ", error);
  }
};

export const postSingleNotificationAsRead = async (id) => {
  const token = localStorage.getItem("accessToken");
  try {
    const markSingleAsRead = await axios.post(
      `${MARK_AS_READ}`,
      { id: id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return markSingleAsRead;
  } catch (error) {
    console.log("error: ", error);
  }
};

export const aquaSwapWalletGeneration = async (payload) => {
  try {
    const { data } = await axios.post(AQUA_SWAP_URL, payload, {
      headers: {
        "x-api-key": "AS-goABF5DIDOy-6iGPTzoQNXY",
      },
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getGeneratedPreview = async (payload) => {
  try {
    const generatedPreview = await axios.post(`${GENERATE_PREVIEW}`, payload);
    return generatedPreview.data?.data;
  } catch (error) {
    console.error("error:", error);
  }
};

export const getGeneratedProfilePreview = async (payload) => {
  try {
    const generatedProfilePreview = await axios.post(`${GENERATE_PROFILE_PREVIEW}`, payload);
    return generatedProfilePreview.data?.data;
  } catch (error) {
    console.error("error:", error);
  }
};

export const getUserProfileHistory = async (offset = 1) => {
  try {
    const accessToken = localStorage.getItem("accessToken");

    const params = {
      limit: 10,
      offset,
    };

    const response = await axios.get(GET_USER_PROFILE_HISTORY, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching user history:", error);
    throw error;
  }
};

export const getFeaturedBlogs = async (perPage, page) => {
  try {
    const getFeaturedBlogsResponse = await axios.get(
      `${API_URL_BLOGS}posts?per_page=${perPage}&page=${page}`
    );
    const totalPosts = getFeaturedBlogsResponse.headers["x-wp-total"];
    const totalPages = getFeaturedBlogsResponse.headers["x-wp-totalpages"];

    return {
      data: getFeaturedBlogsResponse?.data,
      totalPages:
        parseInt(totalPages) || Math.ceil(parseInt(totalPosts) / perPage),
    };
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error;
  }
};

export const getFeaturedCategoriesBlogs = async () => {
  try {
    const getFeaturedBlogsResponse = await axios.get(
      `${API_URL_BLOGS}posts?categories=${FEATURE_BLOG_CATEGORY_ID}`
    );
    return getFeaturedBlogsResponse?.data;
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error;
  }
};

export const getBlogBySlug = async (slug) => {
  try {
    const response = await axios.get(`${API_URL_BLOGS}posts?slug=${slug}`);
    return response?.data[0];
  } catch (error) {
    console.error("Error fetching blog by slug:", error);
    throw error;
  }
};

export const fetchUserProfilePools = async (profileId, offset = 0, type = "publicPools") => {
  if (!profileId) return null;

  try {
    const params = {
      offset,
      limit: 9,
      filter: type,
    };

    const response = await axios.get(`${FETCH_USER_PROFILE_POOLS}${profileId}`, {
      params,
    });

    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching pools by creator:", error);
    throw error;
  }
};

export const postToggleFollow = async (userId) => {
  const token = localStorage.getItem("accessToken");
  try {
    const response = await axios.post(
      `${FOLLOW_TOGGLE}/${userId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error toggling follow:", error);
    throw error;
  }
};
export const postMarketDisclaimer = async () => {
  const token = localStorage.getItem("accessToken");
  try {
    const response = await axios.post(
      `${RISK_MARKET_DISCLAIMER}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error toggling follow:", error);
    throw error;
  }
};

export const getFollowCheck = async (userId) => {
  const token = localStorage.getItem("accessToken");
  try {
    const response = await axios.get(`${FOLLOW_CHECK}/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error checking follow:", error);
  }
};

export const getFollowersList = async (userId) => {
  const token = localStorage.getItem("accessToken");
  try {
    const response = await axios.get(`${FOLLOW_FOLLOWERS}/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching followers:", error);
  }
};

export const getFollowingList = async (userId) => {
  const token = localStorage.getItem("accessToken");
  try {
    const response = await axios.get(`${FOLLOW_FOLLOWING}/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching following:", error);
  }
};

export const toggleFollow = async (userId) => {
  const token = localStorage.getItem("accessToken");
  try {
    const response = await axios.post(`${FOLLOW_TOGGLE}/${userId}`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error toggling follow:", error);
    throw error;
  }
};

export const getProfileTotalVolume = async () => {
  const token = localStorage.getItem("accessToken");
  try {
    const response = await axios.get(`${PROFILE_TOTAL_VOLUME}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data?.data?.data;
  } catch (error) {
    console.error("Error fetching following:", error);
  }
};

export const getFollowStats = async (userId) => {
  const token = localStorage.getItem("accessToken");
  try {
    const response = await axios.get(`${FOLLOW_STATS}/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching following:", error);
  }
};

export const getUserLivePoolsCount = async () => {
  try {
    const token = localStorage.getItem("accessToken");

    const response = await axios.get(GET_USER_LIVE_POOLS_COUNT, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching user live pools count:", error);
  }
};

export const getPredictedMarkets = async (offset = 1, status) => {
  try {
    const token = localStorage.getItem("accessToken");
    const params = {
      offset,
      limit: 10,
    };
    if (status) params.status = status;

    const response = await axios.get(GET_PREDICTED_MARKET, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching user live pools count:", error);
  }
};

export const getProfilePnl = async () => {
  try {
    const token = localStorage.getItem("accessToken");
    const response = await axios.get(GET_PROFILE_PNL, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data?.data?.data;
  } catch (error) {
    console.error("Error fetching user live pools count:", error);
  }
};

export const getPlaceBetData = async (value) => {
  try {
    const response = await axios.post(
      GET_ONGOING_BETS,
      {
        round: value,
      },
    );
    return response?.data?.data;
  } catch (err) {
    throw err;
  }
};

export const getIsGameInProgress = async (startTime, crashDelay, roundIndex) => {
  try {
    const response = await axios.post(
      GET_GAME_PROGRESS,
      { ciphertext: crashDelay, startTime: startTime, roundIndex },
    );
    return response.data.data;
  } catch (err) {
    console.log(err, "err");
    throw err;
  }
};

export const cashoutVerificationSignature = async (smartAccount) => {
  try {
    const response = await axios.post(
      GET_CASHOUT_SIGNATURE,
      {
        walletAddress: smartAccount,
        time: Date.now()
      },
    );
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const getPriceData = async (contractAddress, filter = null) => {
  try {
    const token = localStorage.getItem("accessToken");
    let url = `${GET_GRAPH_PRICES}?contractAddress=${contractAddress}`;
    if (filter && filter !== "ALL") {
      url += `&filter=${filter}`;
    }
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    const dataByPair = response.data.data.reduce((acc, item) => {
      const pairIndex = parseInt(item.pair) - 1;
      if (!acc[pairIndex]) {
        acc[pairIndex] = { percentages: [], timestamps: [] };
      }
      acc[pairIndex].percentages.push(item.percentage);
      acc[pairIndex].timestamps.push(item.createdAt);
      return acc;
    }, []);

    return dataByPair;
  } catch (error) {
    console.error("Error fetching price data:", error);
    throw error;
  }
};

export const getOpenInterest = async () => {
  try {
    const token = localStorage.getItem("accessToken");
    const response = await axios.get(GET_OPEN_INTEREST, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching open interest:", error);
  }
};

export const generateRiskMarketPnLPreview = async (payload) => {
  try {
    const generatedPreview = await axios.post(`${GENERATE_RISK_MARKET_PNL_PREVIEW}`, payload);
    return generatedPreview.data?.data;
  } catch (error) {
    console.error("error:", error);
  }
}

export const uploadProfilePicture = async (base64Image, accessToken) => {
  if (!base64Image) {
    throw new Error("Invalid image format");
  }

  try {
    const base64Data = base64Image.split(",")[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "image/png" });

    const formData = new FormData();
    formData.append("profile", blob, "profile.png");

    const response = await axios.post(
      `${api_url}/users/upload-profile-picture`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const imageUrl = response?.data?.data?.imageUrl;

    if (!imageUrl) {
      throw new Error("Image URL not returned from server");
    }

    return imageUrl;
  } catch (error) {
    console.error("Profile picture upload failed:", error);
    throw error;
  }
};
export const getIsGameActivePlayers = async (round) => {
  try {
    const response = await axios.post(
      GET_GAME_ACTIVE_PLAYERS,
      { round },
    );
    return response.data.data;
  } catch (err) {
    console.log(err, "err");
    throw err;
  }
};